import * as XLSX from "xlsx/xlsx.mjs";

export const exportExcel = (data, name) => {
  const worksheet = XLSX.utils.json_to_sheet(data, {
    // 跳过 Header, 就是把原来表格数据的表头去掉了, headerReplace渲染的数据 "冒充" 表头了
    skipHeader: true,
  });
  const newWorkBook = XLSX.utils.book_new();
  // 把worksheet添加到workbook中
  XLSX.utils.book_append_sheet(newWorkBook, worksheet, "SheetJS");
  // 写入文件, CHROME浏览器会直接下载, 后面的是文件名称和后缀
  XLSX.writeFile(newWorkBook, `${name}.xlsx`);
};
